import _ from 'lodash';
import { createSelector } from 'reselect';

import { makeOptionsWithNull } from 'Common/FormHelper';

const root = state => _.get(state, 'ControlInformationState.haccp');

export const getHACCP = state => _.get(root(state), 'HACCP', []);

export const getSavedHACCP = state => _.get(root(state), 'savedHACCP', false);
export const getSavedHACCPType = state =>
  _.get(root(state), 'savedHACCPType', false);
export const getHACCPType = state => _.get(root(state), 'HACCPType', []);

export const getHACCPTypeOptions = createSelector(getHACCPType, HACCPType => {
  return makeOptionsWithNull(HACCPType);
});

export const getError = state => _.get(root(state), 'error', null);

export const getDeleteHACCP = state => _.get(root(state), 'deleteHACCP', false);

export const getDeleteHACCPType = state =>
  _.get(root(state), 'deleteHACCPType', false);

export const getLoadingHACCP = state =>
  _.get(root(state), 'loadingHACCP', false);

export const getLoadingHACCPType = state =>
  _.get(root(state), 'loadingHACCPType', false);



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/haccp/selectors.js